<template>
    <div class="phone-post-overview" :class="{firstPlan:firstPlan}">
        <div class="container">
            <div class="svg-notch">
                <svg fill="none" viewBox="0 0 509 55">
                    <path fill="#E6E2EB" d="M133.74,12H375.13V31.53a25,25,0,0,1-25,25H158.75a25,25,0,0,1-25-25Z"/>
                </svg>
            </div>
            <div class="bg"></div>
            <div class="viewport hide-scrollbar">
                <slot></slot>
         
            </div>
            <div class="svg">
                <svg class="svg-phone" viewBox="0 0 509 996" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#E6E2EB" d="M0,132.65a4.34,4.34,0,0,1,4.35-4.34H6.52a4.34,4.34,0,0,1,4.35,4.34v28.28a4.34,4.34,0,0,1-4.35,4.34H4.35A4.34,4.34,0,0,1,0,160.93Z"/>
                    <path fill="#E6E2EB" d="M0,203.33A4.35,4.35,0,0,1,4.35,199H6.52a4.35,4.35,0,0,1,4.35,4.35v60.89a4.34,4.34,0,0,1-4.35,4.35H4.35A4.35,4.35,0,0,1,0,264.22Z"/>
                    <path fill="#E6E2EB" d="M0,292.49a4.35,4.35,0,0,1,4.35-4.35H6.52a4.35,4.35,0,0,1,4.35,4.35v60.89a4.34,4.34,0,0,1-4.35,4.35H4.35A4.35,4.35,0,0,1,0,353.38Z"/>
                    <path fill="#E6E2EB" d="M498,226.17a4.35,4.35,0,0,1,4.35-4.35h2.17a4.34,4.34,0,0,1,4.35,4.35V330.55a4.35,4.35,0,0,1-4.35,4.35h-2.17a4.35,4.35,0,0,1-4.35-4.35Z"/>
                    <path fill="#F1EDF5" d="M437.11,0H71.76A66.33,66.33,0,0,0,5.44,66.33V929.67A66.33,66.33,0,0,0,71.76,996H437.11a66.33,66.33,0,0,0,66.33-66.33V66.33A66.33,66.33,0,0,0,437.11,0Zm41.32,914.45A55.45,55.45,0,0,1,423,969.9H85.9a55.44,55.44,0,0,1-55.45-55.45V81.55A55.44,55.44,0,0,1,85.9,26.1H423a55.45,55.45,0,0,1,55.46,55.45Z"/>
                    <path fill="#E6E2EB" d="M430.58,10.87H78.29a62,62,0,0,0-62,62v850.3a62,62,0,0,0,62,62H430.58a62,62,0,0,0,62-62V72.85A62,62,0,0,0,430.58,10.87Zm47.85,903.58A55.45,55.45,0,0,1,423,969.9H85.9a55.44,55.44,0,0,1-55.45-55.45V81.55A55.44,55.44,0,0,1,85.9,26.1H423a55.45,55.45,0,0,1,55.46,55.45Z"/>
                </svg>
            </div>
            
        </div>
    </div>
</template>

<script>

export default {

    props: {
        firstPlan: {
            type: Boolean,
            default: false
        },
    },

    components: {

    },
}
</script>